/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sdh_Removal_CompleteInputs */

const en_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH removal process complete`)
};

const fr_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression SDH terminée`)
};

const de_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH-Entfernungsprozess abgeschlossen`)
};

const it_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completamento del processo di rimozione SDH`)
};

const ru_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процесс удаления SDH завершен.`)
};

const es_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceso de eliminación de SDH completado`)
};

const zh_cn2_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH清除过程已完成`)
};

const ja_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH削除プロセスが完了しました`)
};

const hi_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसडीएच हटाने की प्रक्रिया पूरी हो गई है`)
};

const pt_pt2_sdh_removal_complete = /** @type {(inputs: Sdh_Removal_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processo de remoção de SDH concluído`)
};

/**
* | output |
* | --- |
* | "SDH removal process complete" |
*
* @param {Sdh_Removal_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sdh_removal_complete = /** @type {((inputs?: Sdh_Removal_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sdh_Removal_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sdh_removal_complete(inputs)
	if (locale === "de") return de_sdh_removal_complete(inputs)
	if (locale === "it") return it_sdh_removal_complete(inputs)
	if (locale === "ru") return ru_sdh_removal_complete(inputs)
	if (locale === "es") return es_sdh_removal_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_sdh_removal_complete(inputs)
	if (locale === "ja") return ja_sdh_removal_complete(inputs)
	if (locale === "hi") return hi_sdh_removal_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_sdh_removal_complete(inputs)
	return en_sdh_removal_complete(inputs)
});